import { render } from "./ShiftsTable.vue?vue&type=template&id=a9576442&scoped=true&ts=true"
import script from "./ShiftsTable.ts?vue&type=script&lang=ts"
export * from "./ShiftsTable.ts?vue&type=script&lang=ts"

import "./ShiftsTable.vue?vue&type=style&index=0&id=a9576442&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9576442"]])

export default __exports__